import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { ViewComponent } from './view/view.component';

const routes: Routes = [
  {
    path:'',
    children:[
      {
        path:'candidates-list',component:ListComponent
      },
      {
        path:'add',component:AddComponent
      },
      {
        path:'edit/:id',component:AddComponent
      },
      {
        path:'view/:id',component:ViewComponent
      }    
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CandidatesManagementRoutingModule { }
